<template>
    <!-- Info Modal -->
    <div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered popOutModal">
            <div class="modal-content">
                <div class="modal-body d-flex flex-column py-4 align-items-center justify-content-between">
                    <p class="my-2 fs-3">{{ title }}</p>
                    <p class="my-2 text-secondary">{{ description }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Modal from "bootstrap/js/dist/modal";

const props = defineProps({
    title: String,
    description: String,
});

const emits = defineEmits(['closeModal']);
const modal = ref(null);

onMounted(() => {
    var modalEl = document.getElementById('infoModal');
    modal.value = Modal.getOrCreateInstance(modalEl);
    modal.value.show();

    modalEl.addEventListener('hide.bs.modal', function (event) {
        modalEl.querySelector('.modal-dialog').classList.add('closing');
        setTimeout(() => {
            modalEl.querySelector('.modal-dialog').classList.remove('closing');
        }, 500)
        emits('closeModal');
    });
});

const close = async () => {
    if (modal.value) {
        modal.value.hide();
    }
}

defineExpose({
    close
});
</script>